/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyPickupLocation
 */
export interface ShopifyPickupLocation {
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  postalCode: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  nickname?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  businessName?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  addressLine?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  addressLine2?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  city?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  stateOrProvinceCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  countryCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  contactName?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  contactPhone?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  contactEmail?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  openFromLocalTime?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  openToLocalTime?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyPickupLocation
   */
  hasDock?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyPickupLocation
   */
  hasForklift?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  locationType?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyPickupLocation
   */
  distributionWarehouseBrand?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyPickupLocation
   */
  accessorials?: Array<string> | null;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyPickupLocation
   */
  quotingEnabled: boolean;
}

/**
 * Check if a given object implements the ShopifyPickupLocation interface.
 */
export function instanceOfShopifyPickupLocation(
  value: object,
): value is ShopifyPickupLocation {
  if (!("postalCode" in value) || value["postalCode"] === undefined)
    return false;
  if (!("quotingEnabled" in value) || value["quotingEnabled"] === undefined)
    return false;
  return true;
}

export function ShopifyPickupLocationFromJSON(
  json: any,
): ShopifyPickupLocation {
  return ShopifyPickupLocationFromJSONTyped(json, false);
}

export function ShopifyPickupLocationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyPickupLocation {
  if (json == null) {
    return json;
  }
  return {
    postalCode: json["postalCode"],
    nickname: json["nickname"] == null ? undefined : json["nickname"],
    businessName:
      json["businessName"] == null ? undefined : json["businessName"],
    addressLine: json["addressLine"] == null ? undefined : json["addressLine"],
    addressLine2:
      json["addressLine2"] == null ? undefined : json["addressLine2"],
    city: json["city"] == null ? undefined : json["city"],
    stateOrProvinceCode:
      json["stateOrProvinceCode"] == null
        ? undefined
        : json["stateOrProvinceCode"],
    countryCode: json["countryCode"] == null ? undefined : json["countryCode"],
    contactName: json["contactName"] == null ? undefined : json["contactName"],
    contactPhone:
      json["contactPhone"] == null ? undefined : json["contactPhone"],
    contactEmail:
      json["contactEmail"] == null ? undefined : json["contactEmail"],
    openFromLocalTime:
      json["openFromLocalTime"] == null ? undefined : json["openFromLocalTime"],
    openToLocalTime:
      json["openToLocalTime"] == null ? undefined : json["openToLocalTime"],
    hasDock: json["hasDock"] == null ? undefined : json["hasDock"],
    hasForklift: json["hasForklift"] == null ? undefined : json["hasForklift"],
    locationType:
      json["locationType"] == null ? undefined : json["locationType"],
    distributionWarehouseBrand:
      json["distributionWarehouseBrand"] == null
        ? undefined
        : json["distributionWarehouseBrand"],
    accessorials:
      json["accessorials"] == null ? undefined : json["accessorials"],
    quotingEnabled: json["quotingEnabled"],
  };
}

export function ShopifyPickupLocationToJSON(json: any): ShopifyPickupLocation {
  return ShopifyPickupLocationToJSONTyped(json, false);
}

export function ShopifyPickupLocationToJSONTyped(
  value?: ShopifyPickupLocation | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    postalCode: value["postalCode"],
    nickname: value["nickname"],
    businessName: value["businessName"],
    addressLine: value["addressLine"],
    addressLine2: value["addressLine2"],
    city: value["city"],
    stateOrProvinceCode: value["stateOrProvinceCode"],
    countryCode: value["countryCode"],
    contactName: value["contactName"],
    contactPhone: value["contactPhone"],
    contactEmail: value["contactEmail"],
    openFromLocalTime: value["openFromLocalTime"],
    openToLocalTime: value["openToLocalTime"],
    hasDock: value["hasDock"],
    hasForklift: value["hasForklift"],
    locationType: value["locationType"],
    distributionWarehouseBrand: value["distributionWarehouseBrand"],
    accessorials: value["accessorials"],
    quotingEnabled: value["quotingEnabled"],
  };
}
